import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import Leaderboard from "./pages/Leaderboard";
import Matches from "./pages/Matches";
import MatchDetail from "./pages/MatchDetail";
import PlayerProfile from "./pages/PlayerProfile";
import "./index.css";

function Nav() {
  const linkStyle = ({ isActive }) => ({
    color: isActive ? "#f0a500" : "#9ca3af",
    textDecoration: "none",
    fontWeight: isActive ? "600" : "400",
    padding: "0.5rem 1rem",
    borderBottom: isActive ? "2px solid #f0a500" : "2px solid transparent",
  });
  return (
    <nav style={{ background: "#1a1d26", borderBottom: "1px solid #2d3148", display: "flex", alignItems: "center", padding: "0 1.5rem", gap: "0.5rem" }}>
      <span style={{ color: "#f0a500", fontWeight: "700", fontSize: "1.1rem", marginRight: "1.5rem", padding: "1rem 0" }}>
        🎮 CS2 Stats
      </span>
      <NavLink to="/" end style={linkStyle}>Leaderboard</NavLink>
      <NavLink to="/matches" style={linkStyle}>Matches</NavLink>
    </nav>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Nav />
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "2rem 1rem" }}>
        <Routes>
          <Route path="/" element={<Leaderboard />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/matches/:id" element={<MatchDetail />} />
          <Route path="/players/:steamId" element={<PlayerProfile />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
